import gql from 'graphql-tag'

export const QUERY_GET_EMAIL_CAMPAIGN_BY_ID = gql`
  query Campaign($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      initial_date
      final_date
      frequency {
        type
        interval
      }
      units {
        id_erp
        name
      }
      segments {
        _id
        name
        clients_qty
        clients_qty_at_campaign
      }
      products {
        sku
        name
      }
      message {
        send_date
        send_time
        ... on EmailChannelCampaignMessage {
          subject
          processed_html
          email_configuration_type
          simple_email_configuration {
            text
            subject
            header_image
            image
            click_to_call_button_text
            click_to_call_button_link
            footer
          }
          html_email_configuration {
            has_uploaded_file
            filename
            url
            uploaded_at
          }
          builder_email_configuration
        }
      }
      offers_schedule {
        _id
        name
        description
        segments
        end_date
        start_date
      }
      template_id
    }
  }
`

export const MUTATION_UPSERT_EMAIL_CAMPAIGN = gql`
  mutation UpsertEmailCampaign($data: EmailChannelCampaignInput!) {
    upsertEmailCampaign(data: $data) {
      _id
    }
  }
`

export const MUTATION_DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($id: ID!) {
    deleteCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_UPSERT_DRAFT_EMAIL_CAMPAIGN = gql`
  mutation UpsertDraftEmailCampaign($data: DraftEmailChannelCampaignInput!) {
    upsertDraftEmailCampaign(data: $data) {
      _id
      message
    }
  }
`

export const QUERY_LIST_CAMPAIGNS = gql`
  query Campaigns {
    campaigns(mode: EMAIL) {
      campaigns {
        _id
        title
        status
        description
        initial_date
        final_date
        updated_at
        segments {
          _id
          name
          clients_qty
        }
        products {
          sku
          name
        }
        message {
          text
          send_date
          send_time
          ... on EmailChannelCampaignMessage {
            subject
            header_image
            image
            click_to_call_button_text
            click_to_call_button_link
            footer
          }
        }
      }
    }
  }
`

export const MUTATION_EMAIL_PREVIEW = gql`
  mutation SendPreviewEmail(
    $contacts: [MessagePreviewEmailContactInput!]!
    $processed_html: String!
    $subject: String!
    $variables: MessagePreviewEmailVariablesInput
  ) {
    sendPreviewMessageEmail(contacts: $contacts, processed_html: $processed_html, subject: $subject, variables: $variables)
  }
`
export const MUTATION_CLONE_CAMPAIGN = gql`
  mutation CloneCampaign($id: ID!) {
    cloneCampaign(_id: $id) {
      _id
    }
  }
`

export const QUERY_GET_RESULT_METRICS_EMAIL_CAMPAIGN_BY_ID = gql`
  query Campaign($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      initial_date
      final_date
      segments {
        _id
        name
        clients_qty
      }
      products {
        sku
        name
      }
      message {
        send_date
        send_time
        sendings {
          total
          delivered
        }
      }
      metrics {
        analytic_metrics {
          price
          received_roi
          opened_roi
          average_ticket_received_variation
        }
        clients_metrics {
          sent {
            count
            revenue
            average_ticket
            tickets
          }
          received {
            count
            representation
            revenue
            average_ticket
            tickets
          }
          opened {
            count
            representation
            revenue
            average_ticket
            tickets
          }
          clicked {
            count
            representation
          }
          opened_and_bought {
            count
            representation
            revenue
            average_ticket
            tickets
          }
          opened_with_products {
            count
            representation
            revenue
            average_ticket
            tickets
          }
          opened_with_only_products {
            count
            representation
            revenue
            average_ticket
            tickets
          }
        }
        contacts_metrics {
          validated_quantity
          blacklisted_quantity
        }
        general_metrics {
          general {
            messages_received
            messages_clicked
          }
        }
        products_metrics {
          totals {
            quantity
            revenue
            tickets
            clients
            representation
          }
          table {
            product {
              sku
              name
            }
            received {
              quantity
              revenue
              tickets
              clients
              representation
            }
          }
        }
      }
    }
  }
`

export const QUERY_GET_CREDITS = gql`
  query Balance {
    balance
  }
`

export const QUERY_GET_SCHEDULED_SENDINGS = gql`
  query GetNumberOfScheduledSendings {
    getNumberOfScheduledSendings(mode: EMAIL)
  }
`
export const QUERY_GET_VALID_CONTACTS = gql`
  query GetNumberOfValidContacts {
    getNumberOfValidContacts(mode: EMAIL)
  }
`
export const QUERY_GET_PROVIDER_VALIDATED_CONTACTS = gql`
  query GetNumberOfValidatedContacts {
    getNumberOfValidatedContacts(mode: EMAIL) {
      valid
      invalid
    }
  }
`
export const QUERY_GET_BLACKLISTED_CONTACTS = gql`
  query GetNumberOfBlacklistedContacts {
    getNumberOfBlacklistedContacts(mode: EMAIL)
  }
`

export const QUERY_GET_SEGMENTS_ESTIMATES = gql`
  query GetSegmentsEstimates($segments_ids: [ID!]!) {
    getSegmentsEstimates(segments_ids: $segments_ids) {
      email {
        cost {
          sending
          validation
          credits
        }
        quantity {
          sending
          validation
        }
      }
    }
  }
`

export const QUERY_LIST_TEMPLATES = gql`
  query EmailTemplates($search: String, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    emailTemplates(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      emailTemplates {
        _id
        title
        updated_at
      }
      page
      records
    }
  }
`

export const MUTATION_DELETE_TEMPLATES = gql`
  mutation DeleteEmailTemplate($_id: ID!) {
    deleteEmailTemplate(_id: $_id)
  }
`

export const QUERY_FIND_TEMPLATE = gql`
  query EmailTemplate($_id: ID!) {
    emailTemplate(_id: $_id) {
      _id
      title
      configuration
    }
  }
`

export const MUTATE_UPSERT_TEMPLATE = gql`
  mutation UpsertEmailTemplate($data: EmailTemplateInput!) {
    upsertEmailTemplate(data: $data) {
      _id
    }
  }
`
